import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import { productAccessorHasOffers } from './productAccessorHasOffers'
import { productAccessorHasPersonalCompleteAttribute } from './productAccessorHasPersonalCompleteAttribute'

export const productAccessorIsMasterPage = (
  master: string | null,
  product: PimProductWithVariantsV1,
): boolean =>
  master === 'true' &&
  productAccessorHasOffers(product) &&
  productAccessorHasPersonalCompleteAttribute(product)
